import { memo, ReactNode } from "react";
import { Link, LinkProps } from "../Link";

import styles from "./style.module.scss";

export type LabelWithActionButtonProps = {
  label?: ReactNode
  buttonProps?: LinkProps
}

export const LabelWithActionButton = memo<LabelWithActionButtonProps>((
  {
    label,
    buttonProps,
  }) => {

  return (
    <span className={styles.root}>
      <span className={styles.label}>{label}</span>
      <Link
        tabIndex={-1}
        linkType="s"
        component={"button"}
        type={"button"}
        {...buttonProps}
      />
    </span>
  );
});

export default LabelWithActionButton;
